export enum TableColumns {
  donorID,
  petName,
  ownerLastName,
  bloodType,
  enteredDate,
  daysInReserve,
  notes,
}
